import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { i18n } from './shared/i18n'
import { router } from './app/router'
// Programmatic Message calls are not discovered by the template component resolver.
import '@arco-design/web-vue/es/message/style/css.js'
import './styles/main.css'

createApp(App).use(createPinia()).use(router).use(i18n).mount('#app')
